"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useOnClickOutside;
var _react = require("react");
/**
 * Hook used to track if a click was registered outside of the target component.
 * @function useOnClickOutside
 * @param {Object} [options] - Object of options.
 * @param {Element} options.target - The element to track clicks outside of (will include descendents).
 * @param {Function} [options.callback] - A callback function to call when a click outside is detected.
 * @param {Boolean} [options.enabled=true] - Whether to enable the outside click listeners.
 * @example
 * useOnClickOutside({
 *     target: ref,
 *     callback: onClickOutside,
 * });
 * @returns {void}
 */
function useOnClickOutside() {
  let {
    target,
    callback,
    enabled = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCallback = (0, _react.useCallback)(callback, []);
  (0, _react.useEffect)(() => {
    const onClick = evt => {
      const el = target === null || target === void 0 ? void 0 : target.current;

      // ignore if clicking the target element or any of its descendent elements
      if (!el || el.contains(evt.target)) {
        return;
      }
      if (memoizedCallback) {
        memoizedCallback(evt);
      }
    };
    if (enabled) {
      document.addEventListener('mousedown', onClick);
      document.addEventListener('touchstart', onClick);
    }
    return () => {
      if (enabled) {
        document.removeEventListener('mousedown', onClick);
        document.removeEventListener('touchstart', onClick);
      }
    };
  }, [enabled, target, memoizedCallback]);
}